import React from 'react';
import {Grid, useMediaQuery, useTheme} from "@mui/material";
import useBannerStyles from "../../styles/ncp2026/banner";
import ecran1 from "../../assets/images/ncp/2026/ecran1.png";
import ecran1Mobile from "../../assets/images/ncp/2026/ecran1_mobile.jpg";

const Banner: React.FC = () => {
    const bannerStyles = useBannerStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid container>
            <Grid item xs={12} className={bannerStyles.bannerContainer}>
                <img 
                    src={isMobile ? ecran1Mobile : ecran1} 
                    alt="Banner Kozel 2026" 
                    className={bannerStyles.bannerImage}
                />
            </Grid>
        </Grid>
    );
}

export default Banner;